module.exports = __webpack_public_path__ + "static/img/zhongzhongka16.a9feaae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka16.png
// module id = krdD
// module chunks = 16